import * as t from './actionTypes';

export const initialState = {
  appSiteAssociations: [],
  assetLinks: [],
  espAccounts: [],
  isLoading: false,
  linkShorteningTemplateIds: [],
  sendingDomains: [],
  trackingDomains: [],
  verificationErrors: [],
};

const mailDomainsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.FETCH_MAIL_DOMAINS_RESPONSE: {
      return {
        ...state,
        espAccounts: action.espAccounts,
        sendingDomains: action.sendingDomains,
        trackingDomains: action.trackingDomains,
        verificationErrors: action.verificationErrors,
        linkShorteningTemplateIds: action.linkShorteningTemplateIds,
        defaultSmsLinkShorteningDomain: action.defaultSmsLinkShorteningDomain,
        isLoading: false,
      };
    }
    case t.FETCH_MAIL_DOMAINS_REQUEST:
    case t.CREATE_SENDING_DOMAIN_REQUEST:
    case t.EDIT_SENDING_DOMAIN_REQUEST:
    case t.DELETE_SENDING_DOMAIN_REQUEST:
    case t.CREATE_TRACKING_DOMAIN_REQUEST:
    case t.EDIT_TRACKING_DOMAIN_REQUEST:
    case t.SET_DEFAULT_TRACKING_DOMAIN_REQUEST:
    case t.DELETE_TRACKING_DOMAIN_REQUEST:
    case t.FETCH_DEEP_LINKS_REQUEST:
    case t.CREATE_DEEP_LINK_PATH_REQUEST:
    case t.EDIT_DEEP_LINK_PATH_REQUEST:
    case t.ENABLE_DEEP_LINK_PATH_REQUEST:
    case t.UPSERT_ANDROID_ASSET_LINKS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_MAIL_DOMAINS_ERROR:
    case t.CREATE_SENDING_DOMAIN_ERROR:
    case t.EDIT_SENDING_DOMAIN_ERROR:
    case t.DELETE_SENDING_DOMAIN_ERROR:
    case t.CREATE_TRACKING_DOMAIN_ERROR:
    case t.EDIT_TRACKING_DOMAIN_ERROR:
    case t.SET_DEFAULT_TRACKING_DOMAIN_ERROR:
    case t.DELETE_TRACKING_DOMAIN_ERROR:
    case t.FETCH_DEEP_LINKS_ERROR:
    case t.CREATE_DEEP_LINK_PATH_ERROR:
    case t.EDIT_DEEP_LINK_PATH_ERROR:
    case t.ENABLE_DEEP_LINK_PATH_ERROR:
    case t.UPSERT_ANDROID_ASSET_LINKS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case t.CREATE_SENDING_DOMAIN_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        sendingDomains: [...state.sendingDomains, action.sendingDomain],
      };
    }
    case t.EDIT_SENDING_DOMAIN_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        sendingDomains: action.sendingDomains,
      };
    }
    case t.DELETE_SENDING_DOMAIN_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        sendingDomains: state.sendingDomains.filter(({ id }) => id !== action.sendingDomainId),
      };
    }
    case t.CREATE_TRACKING_DOMAIN_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        trackingDomains: [...state.trackingDomains, action.trackingDomain],
      };
    }
    case t.EDIT_TRACKING_DOMAIN_RESPONSE:
    case t.SET_DEFAULT_TRACKING_DOMAIN_RESPONSE:
    case t.DELETE_TRACKING_DOMAIN_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        trackingDomains: action.trackingDomains,
      };
    }
    case t.FETCH_DEEP_LINKS_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        assetLinks: action.assetLinks,
        appSiteAssociations: action.appSiteAssociations,
      };
    }
    case t.CREATE_DEEP_LINK_PATH_RESPONSE:
    case t.EDIT_DEEP_LINK_PATH_RESPONSE:
    case t.ENABLE_DEEP_LINK_PATH_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        appSiteAssociations: action.appSiteAssociations,
      };
    }
    case t.UPSERT_ANDROID_ASSET_LINKS_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        assetLinks: action.assetLinks,
      };
    }
    default: {
      return state;
    }
  }
};

export default mailDomainsReducer;
